import { Link } from 'react-router-dom';
import { FiClipboard, FiFileText, FiShield, FiSliders } from 'react-icons/fi';
import { type IconType } from 'react-icons';

const FOOTER_LINKS: {
  href: string;
  icon: IconType;
  label: string;
}[] = [
  {
    href: 'https://intertrace.io/en/privacy',
    icon: FiShield,
    label: 'Privacy Policy',
  },
  {
    href: 'https://intertrace.io/en/terms',
    icon: FiFileText,
    label: 'Terms of Service',
  },
  {
    href: 'https://intertrace.io/en/cookies',
    icon: FiSliders,
    label: 'Cookie Policy',
  },
  {
    href: 'https://intertrace.io/en/dpa',
    icon: FiClipboard,
    label: 'Data Processing Addendum',
  },
];

const Footer = ({ className = '' }: { className?: string }) => {
  return (
    <footer
      className={`w-full shrink-0 border-t border-white/10 bg-banner ${className}`.trim()}
    >
      <div className='mx-auto flex w-full max-w-[1400px] flex-col gap-5 px-6 py-6 sm:gap-6 sm:px-10 sm:py-5'>
        <div className='flex w-full flex-col items-start gap-5 sm:flex-row sm:items-center sm:justify-between'>
          <Link className='order-1 transition-opacity hover:opacity-90' to='/'>
            <img
              alt='Intertrace'
              className='h-5 w-auto sm:h-6'
              src='/images/intertrace-logo-full.png'
            />
          </Link>

          <nav className='order-2 flex w-full flex-col items-start gap-2.5 sm:w-auto sm:flex-row sm:flex-wrap sm:items-center sm:justify-end sm:gap-x-5 sm:gap-y-2'>
            {FOOTER_LINKS.map(({ href, icon: Icon, label }) => (
              <a
                key={href}
                className='inline-flex items-center gap-2 text-xs text-white/55 transition-colors hover:text-white/80 sm:text-[13px]'
                href={href}
                rel='noopener noreferrer'
                target='_blank'
              >
                <Icon
                  aria-hidden
                  className='h-3.5 w-3.5 shrink-0 text-greenSecondary/75'
                />
                {label}
              </a>
            ))}
          </nav>
        </div>

        <p className='w-full border-t border-white/10 pt-4 text-left text-xs leading-relaxed text-white/55 sm:text-right sm:text-[13px]'>
          &copy; 2026 Intertrace. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export { Footer };
